// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"style_itemWrapper__1qj5v"};